import {Table, Tag, Typography} from "antd";
import React from "react";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import TagDocumentStatus from "../orders/tag_status_order";
import NextButton from "../../tech/next_button";

export const VisitReturns = (props) => {
    const {t} = useTranslation()
    const navigate = useNavigate()

    const columns = [
        {
            title: t('ID'),
            dataIndex: 'id',
        },
        {
            title: t('document_status'),
            dataIndex: 'document_status_id',
            render: (doc_status, record) => <TagDocumentStatus status={doc_status} tooltip/>
        },
        {
            title: t('status'),
            dataIndex: 'status',
            render: (status) => (
                <>
                    <Tag color={status === 1 ? 'green' : 'volcano'} key={status}>
                        {status === 1 ? t('active') : t('disable')}
                    </Tag>
                </>
            ),
        },
        {
            title: "",
            width:'7%',
            render: (record) => {
                return(
                    <div className={'div-next-button'}>
                        <Link to={`/site/app/returns/${record.id}`} state={{from: `/site/app/visits/${props.visitId}`}}>
                            <NextButton/>
                        </Link>
                    </div>
                )
            }
        }
    ]

    return (
        <>
            <Typography.Title level={5} style={{marginTop:'40pt'}}>{t('returns')}</Typography.Title>
            <Table
                style={{'--cursor': "auto" }}
                columns={columns}
                dataSource={props.data}
                rowKey="id"
                loading={props.wait}
                pagination={false}
                size={"small"}
            />
        </>
    )

}